module.exports = __webpack_public_path__ + "img/07.84b9995a.png";